(function() {
var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

jQuery(function() {
  var membership_invalid_race_number, membership_valid_race_number, validate_membership_race_number;
  $(document).on("keyup", ".choose_race_number_field", function(e) {
    return validate_membership_race_number(e.target);
  });
  validate_membership_race_number = function(target) {
    var _int_value, container, ref, value;
    container = $(target).closest(".membership-series-selector");
    value = target.value;
    if (value === "") {
      return membership_valid_race_number(target);
    } else {
      _int_value = parseInt(value, 10);
      if (isNaN(_int_value)) {
        return membership_valid_race_number(target);
      } else {
        if (ref = _int_value.toString(), indexOf.call($(container.find(".race_numbers")[0]).data("numbers"), ref) >= 0) {
          return membership_valid_race_number(target);
        } else {
          return membership_invalid_race_number(target);
        }
      }
    }
  };
  membership_valid_race_number = function(target) {
    var container;
    container = $(target).closest(".race_number_field");
    container.removeClass("is-invalid at-invalid");
    container.find("input").removeClass("is-invalid at-invalid");
    if (container.find(".help-block-error").length > 0) {
      return container.find(".help-block-error").remove();
    }
  };
  membership_invalid_race_number = function(target) {
    var container;
    container = $(target).closest(".race_number_field");
    container.addClass("is-invalid at-invalid");
    container.find("input").addClass("is-invalid at-invalid");
    if (container.find(".help-block-error").length === 0) {
      return container.find("input").after('<div class="help-block-error">number is not available</div>');
    } else {
      return container.find(".help-block-error").text("number is not available");
    }
  };
  return $(document).on("click", ".membership-series-selector table td", (function(_this) {
    return function(e) {
      var container, number;
      container = $(e.target).closest(".membership-series-selector");
      number = $(e.target).data("number");
      container.find(".choose_race_number_field").val(number);
      $(container.find(".modal")[0]).modal("hide");
      return validate_membership_race_number(e.target);
    };
  })(this));
});

}).call(window);
